import type { Row } from '@tanstack/react-table';
import { Icon, Tooltip } from '@ksyos/design-system';
import type { OrganizationDataError } from '@common/interfaces/api/organizationDataErrorsApi';
import { getSelectedLanguage } from '@frontend/translate';

type KgoStatusCellProps = {
    row: Row<OrganizationDataError>;
};

export default function KgoStatusCell({ row }: Readonly<KgoStatusCellProps>) {
    const translate = getSelectedLanguage();

    return (
        <>
            {row.original.organization.kgoStatus
                ? translate.organization.kgoStatuses[row.original.organization.kgoStatus]
                : ''}
            {row.original.organization.kgoStatusComment && (
                <Tooltip content={row.original.organization.kgoStatusComment}>
                    <Icon
                        icon="contact"
                        sx={{ ml: 2 }}
                    />
                </Tooltip>
            )}
        </>
    );
}
